<template>
  <v-master>
    <div class="py-14 sm:pt-20 sm:pb-36 relative">
      <div class="container max-w-sm">
        <a
          class="block mb-10"
          href="https://carbonii.com/"
        >
          <img
            src="/img/icons/svg/logo-login.svg"
            alt="Carbonii"
            class="mx-auto"
          >
        </a>

        <v-form
          :data="form"
          url="/login"
          method="post"
          @success="onSuccess()"
        >
          <v-input
            v-model="form.email"
            type="email"
            name="email"
            class="mb-5"
            required
            icon="email"
            placeholder="Email"
            input-class="w-full"
          />
          <v-input
            v-model="form.password"
            type="password"
            name="password"
            class="mb-5"
            required
            icon="lock"
            placeholder="Password"
            input-class="w-full"
          />
          <button
            type="submit"
            class="btn btn-primary w-full mt-5"
          >
            Login
          </button>

          <router-link
            :to="'/send-reset-password-request'"
            class="btn btn-white w-full mt-5"
          >
            <span class="mr-2">
              Forgot your password ?
            </span>
          </router-link>

          <a
            class="flex items-center justify-center w-full mt-5 text-center text-gray-700"
            href="https://waitlist.carbonii.com/"
          >
            <span class="mr-2">
              Sign Up Here
            </span>
            <svg
              fill="#000000"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              class="inline"
              width="16px"
              height="16px"
            ><path d="M 5 3 C 3.9069372 3 3 3.9069372 3 5 L 3 19 C 3 20.093063 3.9069372 21 5 21 L 19 21 C 20.093063 21 21 20.093063 21 19 L 21 12 L 19 12 L 19 19 L 5 19 L 5 5 L 12 5 L 12 3 L 5 3 z M 14 3 L 14 5 L 17.585938 5 L 8.2929688 14.292969 L 9.7070312 15.707031 L 19 6.4140625 L 19 10 L 21 10 L 21 3 L 14 3 z" /></svg>
          </a>
        </v-form>
      </div>
    </div>
  </v-master>
</template>

<script>
export default {
  name: "v-login",
  data() {
    return {
      form: {
        email: "",
        password: ""
      }
    };
  },
  methods: {
    onSuccess() {
      let url = "";

      if (localStorage.getItem("login_redirection")) {
        url = localStorage.getItem("login_redirection");
      } else {
        url = "/";
      }

      window.location.href = url;
    }
  }
};
</script>
